export const SUPER_ADMIN_EMAILS: string[] = ["alexandre.emery+17@live.ca", "pepe@rocketcloset.com"];
